"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletedTextDestination = void 0;
var tslib_1 = require("tslib");
var text_destination_1 = require("./text-destination");
var DeletedTextDestination = (function (_super) {
    tslib_1.__extends(DeletedTextDestination, _super);
    function DeletedTextDestination(data) {
        var _this = _super.call(this, data) || this;
        _this.characterProperties = _this.data.subDocumentInfo.characterImporter.properties.clone();
        return _this;
    }
    DeletedTextDestination.prototype.processElementOpen = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2];
            });
        });
    };
    return DeletedTextDestination;
}(text_destination_1.TextDestination));
exports.DeletedTextDestination = DeletedTextDestination;
